import { IDataArray } from './../index';

export class Section implements IDataArray {
    Id: number;
    Name: string;

    public GetById(): number {
        return this.Id;
    }
}
